import PropTypes from 'prop-types'
import React, { useState } from 'react'
import "./RocketPicker.scss"
import Button from "../../common/UI/Button"

function RocketPicker({ rockets, onRocketSelected, onRocketChosen, selected }) {
    const [ currentSelected, setCurrentSelected ] = useState()
    React.useEffect( () => {
        setCurrentSelected(selected)
    },[selected])
   return <>
    <div className={"rocketpicker_container"} >
        <div className="rocketpicker_checkboxes" >
        {rockets && rockets.map((rocket, index) => {
        return <div key={rocket.model} 
                    className={`rocketpicker_option ${rockets.indexOf(currentSelected) === index && "selected"}`} 
                    onClick={ () => {
                        setCurrentSelected(rocket)
                        if (onRocketSelected) {
                            onRocketSelected(rocket)
                        }
                    }
                }>
                { index + 1 }
                </div>
    })
    }
    {currentSelected &&
        <div>
            <h2 className="rocketpicker_model">{currentSelected.model}</h2>
        </div>
    }
    
        </div>

        { currentSelected && <div className="rocketpicker_selected">
            <div className="rocketpicker_img">
               <img src={ currentSelected.image } alt={ currentSelected.model }/>
            </div>

            
            </div>}
        </div> </>
}

export default RocketPicker;

RocketPicker.propTypes = {
  rockets: PropTypes.array
}
